﻿export * from './dom';
export * from './form';
export * from './iconLoader';

/**
 * Returns true if haystack startsWith needle
 */
export function startsWith(haystack: string, needle: string): boolean {
    if (haystack.length >= needle.length) {
        return needle === haystack.substring(0, needle.length);
    }

    return false;
}

/**
 * Serializes an object into a query string
 */
export function querystring(params: object): string {
    return Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key as keyof typeof params])}`)
        .join('&');
}

export function parseQuery(query: string): Record<string, string> {
    if (!query) {
        return {};
    }

    if (query.startsWith('?')) {
        query = query.substring(1);
    }

    const data = query.replace(/&/g, '","').replace(/=/g, '":"');

    return JSON.parse('{"' + data + '"}', (key, value) => key ? decodeURIComponent(value) : value);
}